module.exports = __webpack_public_path__ + "img/Certificate_5.652fefae.jpg";